import axios from 'axios'
import { date } from 'quasar'
import { recursiveAssign } from '@/utils'

export default {
  activities: { data: [], included: [] },
  picklistValues: {},
  picklistTranslations: [],
  products: { data: [] },
  quotes: { data: [], included: [] },
  schema: {},

  verify (obj, type) {
    const existing = this[type].data.find(item => item.id === obj.id)
    if (!existing) this[type].data.push(obj)
    else recursiveAssign(existing, obj)
  },

  verifyIncluded (obj, type) {
    const existing = this[type].included.find(item => item.id === obj.id && item.type === obj.type)
    if (!existing) this[type].included.push(obj)
    else Object.assign(existing, obj)
  },

  verifyPicklistValue (id, valueArr) {
    const existing = this.picklistValues[id]
    if (!existing) this.picklistValues[id] = valueArr
    else Object.assign(existing, valueArr)
  },

  verifyPicklistTranslation (tr) {
    const existing = this.picklistTranslations.find(obj => obj.id === tr.id && obj.attributes.lang === tr.attributes.lang)
    if (!existing) this.picklistTranslations.push(tr)
    else Object.assign(existing, tr)
  },

  verifySchema (mod, sch) {
    const existing = this.schema[mod]
    if (!existing) this.schema[mod] = sch
    else Object.assign(existing, sch)
  },

  getSchema (mod, lang = 'en_us', cbf = null) {
    const existing = this.schema[mod] || {}
    axios.get(`/schema/${mod}?lang=${lang}`)
      .then(res => {
        Object.assign(existing, res.data)
        this.verifySchema(mod, res.data)
        if (cbf) cbf(res.data)
      })
    return existing
  },

  getActivities (curDate, ownerId, cbf = null) {
    const dateStr = date.formatDate(curDate, 'YYYY-MM-DD')
    axios.get(`/activities?page[size]=1000&filter=[{"$eq":["owner_id",${ownerId}]},{"$ne":["%26activity_type","Task"]},{"start_date":"${dateStr}"}]&sort=start_time&include=accounts,contacts&fields[activities]=start_date,start_time,end_time,subject,event_status,activity_type&fields[accounts]=name&fields[contacts]=first_name,last_name`)
      .then(res => {
        res.data.data.forEach(activity => this.verify(activity, 'activities'))
        if (res.data.included) {
          res.data.included.forEach(obj => this.verifyIncluded(obj, 'activities'))
        }
        if (cbf) cbf(this.activities)
      })
    return this.activities
  },

  getActivity (id, cbf = null) {
    const existing = this.activities.data.find(a => a.id === id) || { attributes: {} }
    axios.get('/activities/' + id + '?include=accounts,contacts')
      .then(res => {
        Object.assign(existing, res.data.data)
        this.verify(res.data.data, 'activities')
        // if (res.data.included) {
        //   res.data.included.forEach(obj => this.verify_included(obj))
        // }
        if (cbf) cbf(res.data.data)
      })
    return existing
  },

  updateActivity (activity, cbf = null) {
    axios({
      url: '/activities/' + activity.id,
      method: 'patch',
      data: { data: activity },
      headers: { 'Content-type': 'application/vnd.api+json' }
    })
      .then(res => {
        this.verify(res.data.data, 'activities')
        if (cbf) cbf(true, 'OK')
      })
      .catch(() => {
        if (cbf) cbf(false, 'Unexpected error')
      })
  },

  getPicklistValues (id, cbf = null) {
    const existing = this.picklistValues[id] || []
    axios.get(`picklist-values?page[size]=1000&filter=[{"picklist_id":"${id}"}]`)
      .then(res => {
        const data = res.data.data
        Object.assign(existing, data)
        this.verifyPicklistValue(id, data)
        if (cbf) cbf(data)
      })
    return existing
  },

  getPicklistTranslations (ids = [], lang, cbf = null) {
    const idStr = ids.map(id => `{"id":${id}}`).join(',')
    axios.get(`picklist_value_translation?page[size]=1000&filter=[{"$eq":["lang","${lang}"]},{"$or":[${idStr}]}]`)
      .then(res => {
        res.data.data.forEach(tr => this.verifyPicklistTranslation(tr))
        if (cbf) cbf(this.picklistTranslations)
      })
    return this.picklistTranslations
  },

  getProducts (ids = [], cbf = null) {
    const idStr = ids.map(id => `{"id":${id}}`).join(',')
    axios.get(`/products?page[size]=1000&filter=[{"$or":[${idStr}]}]`)
      .then(res => {
        res.data.data.forEach(product => this.verify(product, 'products'))
        if (cbf) cbf(res.data.data)
        // return res.data.data
      })
  },

  getQuotes (page, cbf = null) {
    // axios.get(`/quotes?page[size]=10&page[number]=${page}&sort=-created_at&fields[quotes]=subject,ship_street,ship_city,ship_zip_code,stage`)
    axios.get(`/quotes?page[size]=10&page[number]=${page}&sort=-created_at`)
      .then(res => {
        res.data.data.forEach(quote => this.verify(quote, 'quotes'))
        if (cbf) cbf(this.quotes)
      })
    return this.quotes
  },

  getQuote (id, cbf = null) {
    const existing = this.quotes.data.find(q => q.id === id) || { attributes: {}, relationships: { rows: { data: [] } } }
    axios.get(`/quotes/${id}?include=rows,rows.product`)
      .then(res => {
        Object.assign(existing, res.data.data)
        this.verify(res.data.data, 'quotes')
        if (res.data.included) {
          res.data.included.forEach(obj => this.verifyIncluded(obj, 'quotes'))
        }
        if (cbf) cbf(res.data)
      })
    return existing
  },

  updateQuote (quote, cbf = null) {
    axios({
      url: '/quotes/' + quote.id,
      method: 'patch',
      data: { data: quote },
      headers: { 'Content-type': 'application/vnd.api+json' }
    })
      .then(res => {
        this.verify(res.data.data, 'quotes')
        if (cbf) cbf(true, 'OK')
      })
      .catch(() => {
        if (cbf) cbf(false, 'Unexpected error')
      })
  },

  getUser (id, cbf = null) {
    axios.get(`/users/${id}`)
      .then(res => {
        if (cbf) cbf(res.data.data)
      })
  },
  getUsers (cbf = null) {
    axios.get('/users?page[size]=1000&fields[users]=first_name,last_name&filter=[{"$eq":["status","Active"]}]')
      .then(res => {
        if (cbf) cbf(res.data)
      })
  }
}
